import styled from 'styled-components'

import { fontSize, fontWeight } from 'src/styles/fonts'
import { color } from 'src/styles/colors'
import { media } from 'src/styles/media'

export const Wrap = styled.div`
  background-image: linear-gradient(221deg, #fffdee, #fef7e2);
  padding: 10rem 0 6.4rem;
`

export const Title = styled.h3`
  max-width: 36rem;
  font-size: ${fontSize.LARGE_XXXL};
  font-weight: ${fontWeight.EXTRA};
  color: ${color.GREYISH_BROWN};
  margin: 3rem 3rem 4rem;

  ${media.desktop} {
    margin: 4rem 12.6rem;
  }
`

export const ResponseMessage = styled.p<{ error?: boolean }>`
  margin-top: 3rem;
  font-weight: ${fontWeight.EXTRA};
  color: ${({ error }) => (error ? color.ORANGEY_RED : color.GREYISH_BROWN)};
`

export const Hr = styled.hr`
  background-color: #f1ecdc;
  border: none;
  height: 0.1rem;
  margin: 3.7rem 0;
`

export const Paragraph = styled.p<{ light?: boolean }>`
  color: ${({ light }) => (light ? color.WARM_GREY : color.GREYISH_BROWN)};
  margin: 0 0 1.4rem;
`
